exports.ISO_MONTH = 'YYYY-MM'
exports.ISO_WEEK = 'YYYY[-W]WW'
exports.ISO_DATE = 'YYYY-MM-DD'
exports.ISO_TIME = 'HH:mm'
exports.IMMUNIZATION = 'MMM YYYY'
